import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';

import FirebaseConsumer from '../../firebaseConsumer';

/**
 * Group an array of rows by user, merging Hits/Targets/InnerX
 * and taking the newest createdAt per user.
 */
function groupByUser(dataArray) {
    const grouped = dataArray.reduce((acc, row) => {
        const key = `${row.participant}-${row.stage}-${row.stand}`;
        if (!acc[key]) {
            // first time we see this user
            acc[key] = {
                participant:  row.participant,
                stage:        row.stage,
                stand:        row.stand,
                scoreHits:    row.scoreHits || 0,
                scoreTargets: row.scoreTargets || 0,
                scoreInner:   row.scoreInner || 0,
                createdAt:    row.createdAt
            };
        } else {
            // merge in any missing values
            acc[key].scoreHits    = acc[key].scoreHits    || row.scoreHits;
            acc[key].scoreTargets = acc[key].scoreTargets || row.scoreTargets;
            acc[key].scoreInner   = acc[key].scoreInner   || row.scoreInner;
            // pick the latest timestamp
            if (new Date(row.createdAt) > new Date(acc[key].createdAt)) {
                acc[key].createdAt = row.createdAt;
            }
        }
        return acc;
    }, {});
    // return as array of rows
    return Object.values(grouped);
}

@observer
class ShotTrainerFieldConsumer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allCommands: [],
        };
        this.firebaseConsumer = new FirebaseConsumer(props.id);

        this.firebaseConsumer.setCommand('result', (data, timestamp) => {
            // console.log('firebaseConsumer result', data, timestamp);
            const { allCommands } = this.state;
            // I want to add to the top of the list
            allCommands.unshift({
                createdAt: timestamp,
                ...data,
            });
            this.setState({ allCommands });
        });
    }

    loadAll = async () => {
        const { id } = this.props;
        // const allCommands = await this.firebaseConsumer.getCommandsByConvention(id);
        // console.log('allCommands', allCommands);
        // this.setState({ allCommands });
    }

    componentDidMount() {
        this.loadAll();
    }

    render() {
        const { allCommands } = this.state;
        const {
            classNames = '',
        } = this.props;
        const { userStore, shotTrainerStore, conventionStore } = this.props.stores;
        const { user = {}, isAdmin, isTester, isVeterinary, isPremium } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const { convention } = conventionStore;
        const { participants, stages } = convention;

        const groupedAllCommands = groupByUser(allCommands);

        return (<>
            {isAdmin && <>
                <div class={`w-100 d-flex flex-column justify-content-center ${classNames} mb-5 mt-5`}>
                    <div class='font-weight-lighter px-3 box-header text-danger'>
                        <Text id='shottrainer.field-consumer-title'>Field consumer</Text>
                    </div>
                    <div class={`d-flex flex-column mx-3 px-3 py-3 box-container ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} border border-danger shadow overflow-auto`} style={`max-height: 50vh;`}>
                        <div class='table-responsive'>
                            <table class='table table-sm table-striped table-hover'>
                                <thead>
                                    <tr>
                                        <th scope='col'>User</th>
                                        <th scope='col'>Stage</th>
                                        <th scope='col'>Stand</th>
                                        <th scope='col'>Hits</th>
                                        <th scope='col'>Targets</th>
                                        <th scope='col'>InnerX</th>
                                        <th scope='col'>Total</th>
                                        <th scope='col'>Created At</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {groupedAllCommands.map((command) => {
                                        const currentUser = participants.find((p) => p.id === command.participant);
                                        const currentStage = stages.find((s) => s.md5 === command.stage);
                                        if (!currentUser || !currentStage) {
                                            console.warn('Missing user or stage for command', command);
                                            return null;
                                        }
                                        return (
                                            <tr>
                                                {/* only show first letter in firstname */}
                                                <td><nobr>{currentUser.firstname?.charAt(0)}.{currentUser.lastname}</nobr></td>
                                                <td>{currentStage.name}</td>
                                                <td class='text-center'>{command.stand}</td>
                                                <td class='text-center font-weight-bold'>{command.scoreHits}</td>
                                                <td class='text-center font-weight-bold'>{command.scoreTargets}</td>
                                                <td class='text-center font-weight-lighter'>{command.scoreInner}</td>
                                                <td class='text-center'>{command.scoreHits || 0 + command.scoreTargets || 0}</td>
                                                {/* <td>{JSON.stringify(command)}</td> */}
                                                <td><nobr>{util.isoDate(command.createdAt, true)}</nobr></td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </>}

        </>);
    }
}

export default ShotTrainerFieldConsumer;
